<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入活动名称" v-model="searchVal" @change="search" style="width:240px;margin-right:30px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button  class="top-btn" type="success" plain @click="handleShow()">添加</el-button >
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData"  height="580">
                <el-table-column prop="title" label="活动名称" align="center" fixed show-overflow-tooltip></el-table-column>
                <el-table-column prop="banner_pic_url" label="首页落地（中）" align="center" width="150">
                    <template slot-scope="scope">
                        <m-img :src="scope.row.banner_pic_url" :width="351" :height="86" />
                    </template>
                </el-table-column>
                <el-table-column prop="banner_pic_en_url" label="首页落地（英）" align="center" width="150">
                    <template slot-scope="scope">
                        <m-img :src="scope.row.banner_pic_en_url" :width="351" :height="86" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="banner_bgcolor" label="落地背景" align="center" width="120"></el-table-column>
                <el-table-column prop="theme_pic_url" label="主题图片（中）" align="center" width="120">
                    <template slot-scope="scope">
                        <m-img :src="scope.row.theme_pic_url" :width="300" :height="150" />
                    </template>
                </el-table-column>
                <el-table-column prop="theme_pic_en_url" label="主题图片（英）" align="center" width="120">
                    <template slot-scope="scope">
                        <m-img :src="scope.row.theme_pic_en_url" :width="300" :height="150" />
                    </template>
                </el-table-column>
                <el-table-column prop="theme_bgcolor" label="主题背景" align="center" width="120"></el-table-column> -->
                <el-table-column prop="item_style" label="商品样式" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.item_style == 1">一行一列</span>
                        <span v-if="scope.row.item_style == 2">一行两列</span>
                        <span v-if="scope.row.item_style == 3">一行三列</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_time_date" label="开始时间" align="center" width="140"></el-table-column>
                <el-table-column prop="end_time_date" label="结束时间" align="center" width="140"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-link type="info" v-if="scope.row.status == 0">未开始</el-link>
                        <el-link type="success" v-if="scope.row.status == 1">进行中</el-link>
                        <el-link type="danger" v-if="scope.row.status == 2">已结束</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="210">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini"  @click="goDetail(scope.row)">详情</el-button>
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="810px" align="center">
            <el-card class="m-bottom-4">
                <el-row>
                    <el-col :span="3" class="input-left">
                        活动名称：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-input v-model="homeActive.title" placeholder="请输入名称" clearable></el-input>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-2">
                    <el-col :span="3" class="input-left">
                        <p>首页落地：</p>
                        <p>（中、英）</p>
                    </el-col>
                    <el-col :span="19" style="display:flex;">
                        <m-upload :img.sync="homeActive.banner"  :width="240" :height="104" file-name="Banner"  placement="right" style="margin-right:20px" />
                        <m-upload :img.sync="homeActive.banner_en"  :width="240" :height="104" file-name="Banner"  placement="right" />
                        <!-- <div class="suggest-size">
                            （*建议尺寸351×86px，JPG、PNG、GIF等格式图片）
                        </div> -->
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="22" class="suggest-size">
                        （*建议尺寸351×86px，JPG、PNG、GIF等格式图片）
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3" class="input-left">
                        落地背景：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-input v-model="homeActive.banner_bgcolor" placeholder="请输入背景色，例#000000">
                            <colorPicker v-model="homeActive.banner_bgcolor" class="color_select" slot="prefix" />
                        </el-input>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="3" class="input-left">
                        <p>主题图片：</p>
                        <p>（中、英）</p>
                    </el-col>
                    <el-col :span="19" style="display:flex;">
                        <m-upload :img.sync="homeActive.theme"  :width="240" :height="104" file-name="Banner"  placement="right" style="margin-right:20px"/>
                        <m-upload :img.sync="homeActive.theme_en"  :width="240" :height="104" file-name="Banner"  placement="right" />
                        <!-- <div class="suggest-size">
                            （*建议尺寸343×162px，JPG、PNG、GIF等格式图片）
                        </div> -->
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3" class="input-left">
                        主题背景：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-input v-model="homeActive.theme_bgcolor" placeholder="请输入背景色，例#000000">
                            <colorPicker v-model="homeActive.theme_bgcolor" class="color_select" slot="prefix" />
                        </el-input>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-4">
                    <el-col :span="3" class="input-left">
                        开始时间：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-date-picker v-model="homeActive.start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间"></el-date-picker>
                    </el-col>
                </el-row> 
                <el-row>
                    <el-col :span="3" class="input-left">
                        结束时间：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-date-picker v-model="homeActive.end_time" value-format="timestamp"  type="datetime" placeholder="选择结束时间"></el-date-picker>
                    </el-col>
                </el-row>  
            </el-card>
            <el-card  class="m-bottom-4">
                <el-row>
                    <el-col :span="3" class="input-left">
                        商品样式：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-radio-group v-model="homeActive.item_style">
                            <el-radio :label="1" border>一行一列</el-radio>
                            <el-radio :label="2" border>一行两列</el-radio>
                            <el-radio :label="3" border>一行三列</el-radio>
                        </el-radio-group>
                </el-col>
                </el-row>
            </el-card>
            <el-card>
                <el-row>
                    <el-col :span="3" class="input-left">
                        提交信息：
                    </el-col>
                    <el-col :span="19" class="input-left">
                        <el-button :disabled="disabled"  @click="handleBtn()" type="success" plain>确认提交</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </el-dialog>
    </section>
</template>
<script>
import {  landing_page_list, landing_page_edit, landing_page_add, landing_page_del } from '@/api/market.js'
import { parseTime } from '@/untils/index.js'
import MUpload from '@/components/m-upload.vue'
import MImg  from '@/components/Image'
export default {
    components:{ MUpload, MImg },
    data() {
        return {
            searchVal: '',
            tableData:[],
            table_load:false,
            total:0,
            page: 1,
            size: 0,
            textarea: '',
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加主题活动',
            disabled: false,
            homeActive: {
                title:'',
                banner_bgcolor:'',
                theme_bgcolor:'',
                start_time: '',
                end_time  : '',
                id: '',
                item_style: 1,
                banner: { pic_id: '', url: '' },
                banner_en: { pic_id: '', url: '' },
                theme: { pic_id: '', url: '' },
                theme_en: { pic_id: '', url: '' },
            },
            row: {}
        }
    },
    methods: {
        search() {
            this.page = 1
            this.getData()
        },
        getData() {  
            let params = {
                page:this.page,
            }
            if(this.searchVal != '') {
                params.search = this.searchVal
            }
            landing_page_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        // 显示 添加 || 修改 弹窗
        handleShow(row) {
            this.dialog = true
            if(row) {
                this.row = row
                this.dialogTitle = '修改主题活动'
                this.homeActive.id = row.id
                this.homeActive.title = row.title 
                this.homeActive.start_time = new Date(row.start_time_date)
                this.homeActive.end_time = new Date(row.end_time_date)
                this.homeActive.banner.pic_id = row.banner_pic
                this.homeActive.banner_en.pic_id = row.banner_pic_en
                this.homeActive.banner.url = row.banner_pic_url
                this.homeActive.banner_en.url = row.banner_pic_en_url
                this.homeActive.banner_bgcolor = row.banner_bgcolor
                this.homeActive.theme.pic_id = row.theme_pic
                this.homeActive.theme_en.pic_id = row.theme_pic_en
                this.homeActive.theme.url = row.theme_pic_url
                this.homeActive.theme_en.url = row.theme_pic_en_url
                this.homeActive.theme_bgcolor = row.theme_bgcolor
                this.homeActive.item_style = row.item_style               
            } else {
                this.dialogTitle = '添加主题活动'
                this.homeActive.id = ''
                this.homeActive.title = ''
                this.homeActive.start_time = ''
                this.homeActive.end_time =''
                this.homeActive.banner.pic_id = ''
                this.homeActive.banner_en.pic_id = ''
                this.homeActive.banner_bgcolor = ''
                this.homeActive.theme.pic_id = ''
                this.homeActive.theme_en.pic_id = ''
                this.homeActive.theme_bgcolor = ''
                this.homeActive.item_style = 1
            }
        },
        // 弹窗里面 点击确定
        handleBtn() {
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.homeActive.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
        },
        // 添加 活动
        handleAdd() {
            if(this.homeActive.title == "") {
                this.$message({message:'请输入活动名称', type:'warning'})
                return false
            }
            if(this.homeActive.banner.pic_id == "") {
                this.$message({message:'请添加落地图（中）', type:'warning'})
                return false
            }
            if(this.homeActive.banner_en.pic_id == "") {
                this.$message({message:'请添加首页落地图（英）', type:'warning'})
                return false
            }
            if(this.homeActive.banner_bgcolor == "") {
                this.$message({message:'请输入落地页背景色', type:'warning'})
                return false
            }
            if(this.homeActive.theme.pic_id == "") {
                this.$message({message:'请添加主题图片（中）', type:'warning'})
                return false
            }
            if(this.homeActive.theme_en.pic_id == "") {
                this.$message({message:'请添加主题图片（英）', type:'warning'})
                return false
            }
            if(this.homeActive.theme_bgcolor == "") {
                this.$message({message:'请输入主题背景色', type:'warning'})
                return false
            }
            if(this.homeActive.start_time == "") {
                this.$message({message:'请选择开始时间', type:'warning'})
                return false
            }
            if(this.homeActive.end_time == "") {
                this.$message({message:'请选择结束时间', type:'warning'})
                return false
            }
            
            let params = {
                title:this.homeActive.title,
                start_time:parseTime(this.homeActive.start_time/1000),
                end_time:parseTime(this.homeActive.end_time/1000),
                banner_pic:this.homeActive.banner.pic_id,
                banner_pic_en:this.homeActive.banner_en.pic_id,
                banner_bgcolor:this.homeActive.banner_bgcolor,
                theme_pic:this.homeActive.theme.pic_id,
                theme_pic_en:this.homeActive.theme_en.pic_id,
                theme_bgcolor:this.homeActive.theme_bgcolor,
                item_style:this.homeActive.item_style,
            }
            this.disabled = true
            landing_page_add(params).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                    this.dialog   = false
                }
            }).finally( () => {
                this.disabled = false
            })
        },
        // 修改 活动
        handlePut() {
            if(this.homeActive.title == "") {
                this.$message({message:'请输入活动名称', type:'warning'})
                return false
            }
            if(this.homeActive.banner.pic_id == "") {
                this.$message({message:'请添加首页落地页图（中）', type:'warning'})
                return false
            }
            if(this.homeActive.banner_en.pic_id == "") {
                this.$message({message:'请添加首页落地页图（英）', type:'warning'})
                return false
            }
            if(this.homeActive.banner_bgcolor == "") {
                this.$message({message:'请输入落地页背景色', type:'warning'})
                return false
            }
            if(this.homeActive.theme.pic_id == "") {
                this.$message({message:'请添加主题图片（中）', type:'warning'})
                return false
            }
            if(this.homeActive.theme_en.pic_id == "") {
                this.$message({message:'请添加主题图片（英）', type:'warning'})
                return false
            }
            if(this.homeActive.theme_bgcolor == "") {
                this.$message({message:'请输入主题背景色', type:'warning'})
                return false
            }
            if(this.homeActive.start_time == "") {
                this.$message({message:'请选择开始时间', type:'warning'})
                return false
            }
            if(this.homeActive.end_time == "") {
                this.$message({message:'请选择结束时间', type:'warning'})
                return false
            }
            let params = {
                title:this.homeActive.title,
                banner_pic:this.homeActive.banner.pic_id,
                banner_pic_en:this.homeActive.banner_en.pic_id,
                banner_bgcolor:this.homeActive.banner_bgcolor,
                theme_pic:this.homeActive.theme.pic_id,
                theme_pic_en:this.homeActive.theme_en.pic_id,
                theme_bgcolor:this.homeActive.theme_bgcolor,
                item_style:this.homeActive.item_style,
            }
            if(new Date(this.row.start_time_date).getTime() != new Date(this.homeActive.start_time).getTime()) {
                params.start_time = parseTime(this.homeActive.start_time/1000)
            }
            if(new Date(this.row.end_time_date).getTime() != new Date(this.homeActive.end_time).getTime()) {
                params.end_time = parseTime(this.homeActive.end_time/1000)
            }
            this.disabled = true
            landing_page_edit(this.homeActive.id, params).then(res => {
               if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                    this.dialog   = false
                }
            }).finally( () => {
                this.disabled = false
            })
        },
        // 删除 活动
        handleDel(row) {
            this.$confirm(`此操作将删除活动："${row.title}"，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                landing_page_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            }).catch(() => {
                          
            });
        },
        // 跳转活动详情
        goDetail(row) {
            this.$router.push( `/market/active/landing/${row.id}` )
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .top-btn {
        width: 100px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
        text-align: left;
    }
    /deep/.m-bottom-4 .el-input,.el-textarea {
        width: 400px;
    }
    .suggest-size {
        color: grey;
        font-size: 0.9em;
    }
    /deep/ .color_select {
        cursor: pointer;
    }
    /deep/ .el-card {
        overflow: unset;
    }
}
</style>
